var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramSocialLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2571 21.6099C19.3799 21.6099 21.9114 19.1574 21.9114 16.1322C21.9114 13.107 19.3799 10.6545 16.2571 10.6545C13.1342 10.6545 10.6027 13.107 10.6027 16.1322C10.6027 19.1574 13.1342 21.6099 16.2571 21.6099Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 24.4968C32 28.3583 28.7571 31.5 24.7709 31.5H7.22913C3.243 31.5 0 28.3584 0 24.4968V7.50322C0 3.64165 3.24292 0.5 7.22913 0.5H24.7709C28.757 0.5 32 3.64158 32 7.50322V24.4968ZM25.6478 5.1599C26.0535 5.1599 26.4509 5.31928 26.738 5.59738C27.0251 5.87548 27.1896 6.26046 27.1896 6.65353C27.1896 7.04652 27.0251 7.43151 26.738 7.70968C26.4509 7.98785 26.0535 8.14716 25.6478 8.14716C25.2421 8.14716 24.8447 7.98778 24.5576 7.70968C24.2705 7.43151 24.106 7.04717 24.106 6.65353C24.106 6.25988 24.2705 5.87555 24.5576 5.59738C24.8447 5.31921 25.2421 5.1599 25.6478 5.1599ZM24.739 16.1325C24.739 20.6704 20.9416 24.349 16.2574 24.349C11.5732 24.349 7.77588 20.6704 7.77588 16.1325C7.77588 11.5947 11.5732 7.91605 16.2574 7.91605C20.9416 7.91605 24.739 11.5947 24.739 16.1325Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramSocialLogo);
export default __webpack_public_path__ + "static/media/instagram-social-logo.3fb0bf620cf05fd57f681ed5494bfdf9.svg";
export { ForwardRef as ReactComponent };